module.exports = __webpack_public_path__ + "static/media/CTLI_11-235w.1b13a2a0.png";